import { useMemo } from 'react';
import { UseCurrencyReturn } from './useCurrency';
import { UseInstrumentReturn } from './useInstrument';

interface UseMinOrderSizeParams {
    instrument: UseInstrumentReturn;
    activeCurrencyConfig: UseCurrencyReturn;
}

interface UseMinOrderSizeReturn {
    orderDecimals: number;
    minOrderSize: number;
}

const useMinOrderSize = (props: UseMinOrderSizeParams): UseMinOrderSizeReturn => {
    const { instrument, activeCurrencyConfig } = props;

    const { orderDecimals, minOrderSize } = useMemo(() => {
        const instrumentType = instrument?.type || '';

        const isCcyConfig =
            instrumentType === 'FX' || (instrumentType === 'Crypto' && instrument.config.subType === 'Spot');

        return {
            orderDecimals: isCcyConfig ? activeCurrencyConfig.order_decimals : instrument.quantityDecimals ?? 0,
            minOrderSize: isCcyConfig ? activeCurrencyConfig.min_order_size : instrument.min_order_size ?? 0
        };
    }, [instrument, activeCurrencyConfig]);

    return { orderDecimals, minOrderSize };
};

export default useMinOrderSize;
